module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-3-0237be81ebcd574410a29a2d80b10656.jpg";